import { Link } from 'react-router-dom'

import CloseIconBlack from '../../../img/close-icon-black.svg'
import CloseIcon from '../../../img/close-icon-white.svg'

const ModalHeaderHeading = props => (
  <div className="dashboard-modal__header__heading">
    <img src={props.pageIcon} alt="" />
    <label>{props.pageName}</label>
    <div className="close">
      {props.whiteTheme ? (
        <Link to="/dashboard" onClick={props.handleTransactions}>
          <img src={CloseIconBlack} alt="" />
        </Link>
      ) : (
        <Link to="/dashboard" onClick={props.handleTransactions}>
          <img src={CloseIcon} alt="" />
        </Link>
      )}
    </div>
  </div>
)

const ModalHeaderTitle = props => (
  <div className="dashboard-modal__header__title">{props.title}</div>
)

const ModalHeaderSubTitle = props => (
  <div className="dashboard-modal__header__sub-title">
    <p>{props.subTitle}</p>
  </div>
)

const ModalHeader = props => (
  <div className="dashboard-modal__header">
    {ModalHeaderHeading(props)}
    {ModalHeaderTitle(props)}
    {ModalHeaderSubTitle(props)}
    {props.children}
  </div>
)
export default ModalHeader
